import * as React from 'react'

function SvgAdminsIcon(props) {
  return (
    <svg
      width="2em"
      // height="1em"
      viewBox="0 0 32 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={32} height={31} rx={10} fill="#fff" />
      <path
        d="M23.502 13.674h-.757a7.38 7.38 0 00-.83-2.006l.535-.535a.498.498 0 000-.704L20.57 8.55a.498.498 0 00-.704 0l-.535.536a7.377 7.377 0 00-2.006-.831v-.757A.498.498 0 0016.828 7h-2.656a.498.498 0 00-.498.498v.757a7.376 7.376 0 00-2.006.83l-.535-.535a.498.498 0 00-.704 0L8.55 10.43a.498.498 0 000 .704l.536.535a7.377 7.377 0 00-.831 2.006h-.757a.498.498 0 00-.498.498v2.656c0 .275.223.498.498.498h.757c.177.708.455 1.38.83 2.006l-.535.535a.498.498 0 000 .704l1.879 1.878c.194.195.51.195.704 0l.535-.535a7.38 7.38 0 002.006.831v.757c0 .275.223.498.498.498h2.656a.498.498 0 00.498-.498v-.757a7.38 7.38 0 002.006-.83l.535.535c.194.194.51.194.704 0l1.878-1.879a.498.498 0 000-.704l-.535-.535a7.38 7.38 0 00.831-2.006h.757a.498.498 0 00.498-.498v-2.656a.498.498 0 00-.498-.498zM15.5 20.647a5.152 5.152 0 01-5.146-5.147 5.152 5.152 0 015.146-5.146 5.152 5.152 0 015.146 5.146 5.152 5.152 0 01-5.146 5.146z"
        fill="#FF7B0D"
      />
      <path
        d="M15.5 15.998a1.162 1.162 0 100-2.324 1.162 1.162 0 000 2.324zM15.5 16.994c-1.155 0-2.1.91-2.156 2.052a4.125 4.125 0 002.156.604c.788 0 1.527-.22 2.155-.604a2.16 2.16 0 00-2.155-2.052z"
        fill="#FF7B0D"
      />
      <path
        d="M15.5 11.35a4.155 4.155 0 00-4.15 4.15c0 1.088.42 2.079 1.107 2.82a3.168 3.168 0 011.538-1.94 2.151 2.151 0 01-.653-1.544 2.16 2.16 0 012.158-2.158 2.16 2.16 0 012.158 2.158c0 .605-.25 1.152-.653 1.545a3.168 3.168 0 011.538 1.939 4.134 4.134 0 001.107-2.82 4.155 4.155 0 00-4.15-4.15z"
        fill="#FF7B0D"
      />
    </svg>
  )
}

export default SvgAdminsIcon
